/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1UserUseridTemporaryPasswordConfirm200,
  GetApiV1UserUseridTemporaryPasswordConfirm400,
  GetApiV1UserUseridTemporaryPasswordConfirm401,
  GetApiV1UserUseridTemporaryPasswordConfirm500,
  GetApiV1UserUseridTemporaryPasswordConfirmPathParams,
  GetApiV1UserUseridTemporaryPasswordConfirmQueryResponse,
} from "../../types/userCredenciaisController/GetApiV1UserUseridTemporaryPasswordConfirm.ts";
import { detailUserViewModelSchema } from "../detailUserViewModelSchema.ts";

export const getApiV1UserUseridTemporaryPasswordConfirmPathParamsSchema =
  z.object({
    userId: z.coerce.number().int(),
  }) as unknown as ToZod<GetApiV1UserUseridTemporaryPasswordConfirmPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1UserUseridTemporaryPasswordConfirm200Schema = z.lazy(
  () => detailUserViewModelSchema,
) as unknown as ToZod<GetApiV1UserUseridTemporaryPasswordConfirm200>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const getApiV1UserUseridTemporaryPasswordConfirm400Schema =
  z.any() as unknown as ToZod<GetApiV1UserUseridTemporaryPasswordConfirm400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1UserUseridTemporaryPasswordConfirm401Schema =
  z.any() as unknown as ToZod<GetApiV1UserUseridTemporaryPasswordConfirm401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1UserUseridTemporaryPasswordConfirm500Schema =
  z.any() as unknown as ToZod<GetApiV1UserUseridTemporaryPasswordConfirm500>;

export const getApiV1UserUseridTemporaryPasswordConfirmQueryResponseSchema =
  z.lazy(
    () => getApiV1UserUseridTemporaryPasswordConfirm200Schema,
  ) as unknown as ToZod<GetApiV1UserUseridTemporaryPasswordConfirmQueryResponse>;
